(function () {
  'use strict';

  if (customElements.get('tire-model-variants')) return;

  function text(value) {
    return value == null ? '' : String(value);
  }

  function numberSort(a, b) {
    return Number(a) - Number(b);
  }

  function localUrl(root, url) {
    var cleanRoot = text(root || '/').replace(/\/$/, '');
    var cleanUrl = text(url || '/');
    if (!cleanRoot || cleanRoot === '/' || cleanUrl.indexOf(cleanRoot + '/') === 0) return cleanUrl;
    return cleanRoot + (cleanUrl.charAt(0) === '/' ? cleanUrl : '/' + cleanUrl);
  }

  function modelBase(model, oe) {
    var value = text(model).trim().replace(/\s+/g, ' ');
    var suffix = text(oe).trim();
    if (suffix) {
      var escaped = suffix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      value = value.replace(new RegExp('\\s+' + escaped + '$', 'i'), '').trim();
    }
    return value.toLocaleLowerCase();
  }

  function broadTags(model) {
    var blocked = { ALL: true, SEASON: true, SOMMER: true, WINTER: true, TYRE: true, TIRE: true };
    return text(model).toUpperCase().match(/[A-Z0-9][A-Z0-9+.-]*/g)?.filter(function (part) {
      return part.length >= 3 && !/^\d+$/.test(part) && !blocked[part];
    }).slice(0, 3) || [];
  }

  class TireModelVariants extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.controls = this.querySelector('[data-tmv-controls]');
      this.sizes = this.querySelector('[data-tmv-sizes]');
      this.results = this.querySelector('[data-tmv-results]');
      this.count = this.querySelector('[data-tmv-count]');
      try {
        this.currentProduct = JSON.parse(this.querySelector('[data-tmv-current]')?.textContent || 'null');
      } catch (error) {
        this.currentProduct = null;
      }
      this.load();
    }

    async load() {
      var vendorTag = "tag:'" + this.dataset.vendor.replace(/'/g, '') + "'";
      var exactQuery = vendorTag + " AND tag:'" + this.dataset.modelTag.replace(/'/g, '') + "'";
      var words = broadTags(this.dataset.modelBase || this.dataset.model);
      var broadQuery = words.length ? vendorTag + ' AND ' + words.map(function (word) {
        return "tag:'" + word.replace(/'/g, '') + "'";
      }).join(' AND ') : exactQuery;
      /* Always query the canonical catalogue index. Localised Shopify search
         indexes can lag behind one another; product links are localised again
         by localUrl() when the cards are rendered. */
      var endpoint = this.dataset.endpoint || '/search';

      try {
        var families = await Promise.all([this.fetchFamily(endpoint, exactQuery), this.fetchFamily(endpoint, broadQuery)]);
        var merged = new Map();
        families.flat().forEach(function (product) { merged.set(product.handle, product); });
        if (this.currentProduct?.handle) merged.set(this.currentProduct.handle, this.currentProduct);
        var expectedModel = modelBase(this.dataset.modelBase || this.dataset.model, '');
        var expectedVendor = text(this.dataset.vendor).toLocaleLowerCase();
        this.products = Array.from(merged.values()).filter(function (product) {
          return text(product.vendor).toLocaleLowerCase() === expectedVendor && modelBase(product.model, product.oe) === expectedModel;
        }).sort(function (a, b) {
          return numberSort(a.width, b.width) || numberSort(a.aspect, b.aspect) || numberSort(a.rim, b.rim) || numberSort(a.price, b.price);
        });

        if (!this.products.length) {
          this.count.textContent = this.dataset.labelEmpty;
          return;
        }

        this.controls.hidden = false;
        this.populateSizes();
        this.render();
      } catch (error) {
        this.count.textContent = this.dataset.labelError;
        this.results.innerHTML = '';
        console.warn('[VANTIQ] Modellvarianten:', error);
      }
    }

    async fetchFamily(endpoint, query) {
      var base = endpoint + '?view=tire-variants&type=product&q=' + encodeURIComponent(query);
      var products = [];
      var pages = 1;
      for (var page = 1; page <= pages && page <= 5; page++) {
        var response = await fetch(base + (page > 1 ? '&page=' + page : ''), { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        var payload = await response.json();
        products = products.concat(payload.products || []);
        pages = Math.max(1, Number(payload.pages) || 1);
      }
      return products;
    }

    dimensionKey(product) {
      return [product.width, product.aspect, product.rim].map(text).join('|');
    }

    populateSizes() {
      var currentKey = [this.dataset.currentWidth, this.dataset.currentAspect, this.dataset.currentRim].join('|');
      var dimensions = new Map();
      this.products.forEach((product) => dimensions.set(this.dimensionKey(product), product));
      var entries = Array.from(dimensions.entries()).sort(function (a, b) {
        if (a[0] === currentKey) return -1;
        if (b[0] === currentKey) return 1;
        return numberSort(a[1].rim, b[1].rim) || numberSort(a[1].width, b[1].width) || numberSort(a[1].aspect, b[1].aspect);
      });
      this.selectedDimension = dimensions.has(currentKey) ? currentKey : entries[0]?.[0];
      this.sizes.innerHTML = '';
      entries.forEach(([key, product]) => {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'tmv-size';
        button.dataset.dimension = key;
        button.setAttribute('aria-pressed', key === this.selectedDimension ? 'true' : 'false');
        button.textContent = product.width + '/' + product.aspect + ' R' + product.rim;
        button.addEventListener('click', () => {
          this.selectedDimension = key;
          this.sizes.querySelectorAll('.tmv-size').forEach(function (item) {
            item.setAttribute('aria-pressed', item.dataset.dimension === key ? 'true' : 'false');
          });
          this.render();
        });
        this.sizes.appendChild(button);
      });
    }

    render() {
      var selected = this.selectedDimension;
      var matches = this.products.filter((product) => this.dimensionKey(product) === selected);

      this.count.textContent = this.products.length + ' ' + (this.products.length === 1 ? this.dataset.labelCountSingular : this.dataset.labelCountPlural);
      this.results.innerHTML = '';
      if (!matches.length) {
        var empty = document.createElement('p');
        empty.className = 'tmv__empty';
        empty.textContent = this.dataset.labelEmpty;
        this.results.appendChild(empty);
        return;
      }

      matches.forEach((product) => this.results.appendChild(this.card(product)));
    }

    card(product) {
      var current = product.handle === this.dataset.currentHandle;
      var link = document.createElement('a');
      link.className = 'tmv-card' + (current ? ' tmv-card--current' : '');
      link.href = localUrl(this.dataset.root, product.url);
      if (current) link.setAttribute('aria-current', 'page');

      var size = document.createElement('span');
      size.className = 'tmv-card__size';
      size.textContent = product.width + '/' + product.aspect + ' R' + product.rim;
      if (current) {
        var badge = document.createElement('span');
        badge.className = 'tmv-card__badge';
        badge.textContent = this.dataset.labelCurrent;
        size.appendChild(badge);
      }

      var meta = document.createElement('span');
      meta.className = 'tmv-card__meta';
      var detail = [text(product.load) + text(product.speed), product.xl ? 'XL' : '', text(product.oe)].filter(Boolean);
      meta.textContent = detail.length ? this.dataset.labelLoad + ': ' + detail.join(' · ') : '';

      var price = document.createElement('span');
      price.className = 'tmv-card__price';
      var locale = this.dataset.locale || 'de';
      if (locale.length === 2) locale += '-CH';
      price.textContent = new Intl.NumberFormat(locale, {
        style: 'currency', currency: this.dataset.currency || 'CHF'
      }).format(Number(product.price || 0) / 100);

      var stock = document.createElement('span');
      stock.className = 'tmv-card__stock';
      stock.textContent = product.available ? this.dataset.labelInStock : this.dataset.labelUnavailable;

      link.append(size, meta, price, stock);
      return link;
    }

    // Das ProductGroup-Markup schrieb früher dieses Skript. Es steht seit dem
    // 16.09.2026 serverseitig in snippets/tire-product-schema.liquid: Hier
    // hängte es alle Grössen als eigene Produkte an jede Seite.
  }

  customElements.define('tire-model-variants', TireModelVariants);
})();
